export default "__VITE_ASSET__03ac2d81__"